import { createSelector } from 'reselect';

export const getServicesTab = (state) => state.servicesTab;

export const getEditActions = createSelector(getServicesTab, ({ editActions }) => editActions);
